import React, { useState } from "react";
import styled from "styled-components";

const DetailContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 400px;
    height: 600px;

    @media all and (max-width:479px) {
        width: 40%;
        height: 60%;
    }
`;

const TypeBox = styled.div`
    width: 390px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;

    @media all and (max-width:479px) {
        width: 100%;
        height: 20%;
    }
`;

const PropertyBox = styled.div`
    width: 390px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;

    @media all and (max-width:479px) {
        width: 100%;
        height: 20%;
    }
`;

const StatsBox = styled.div`
    width: 390px;
    height: 280px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;

    @media all and (max-width:479px) {
        width: 100%;
        height: 20%;
    }
`;

const StyledTitle = styled.span`
    font-size: 22px;

    @media all and (max-width:479px) {
        font-size: 0.75rem;
    }
`;

const CategoryBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 10px;

    @media all and (max-width:479px) {
        width: 100%;
        height: 20%;
    }
`;

const TypeColors = {
    불꽃: "#E56C3E",
    물: "#5185C5",
    풀: "#67A945",
    전기: "#FBB917",
    독: "#735198",
    비행: "#A3C3E7",
    벌레: "#A0A244",
    땅: "#9C7743",
    바위: "#BFB889",
    고스트: "#684870",
    강철: "#6AA9C7",
    격투: "#E09C41",
    노말: "#949495",
    에스퍼: "#DE6B7A",
    얼음: "#6CC8EB",
    드래곤: "#535CA8",
    악: "#4B4948",
    페어리: "#EBD5E8",
};

const StyledSpan = styled.span`
    font-size: 14px;
    padding: 5px 10px;
    background-color: ${({ type }) => TypeColors[type]};
    margin-top: 5px;
    border-radius: 10px;
    color: white;
    position: relative;

    @media all and (max-width:479px) {
        font-size: 0.5rem;
    }
`;

const PropertySpan = styled.span`
    font-size: 14px;
    padding: 5px 10px;
    background-color: green;
    margin-top: 5px;
    border-radius: 10px;
    color: white;
    position: relative;

    &:hover {
        background-color: #60c0a8;
    }

    @media all and (max-width:479px) {
        font-size: 0.5rem;
    }
`;

const StatBox = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 5px;
    border-bottom: 1px solid #ddd;
`;

const StatLabel = styled.span`
    font-size: 16px;

    @media all and (max-width:479px) {
        font-size: 0.5rem;
    }
`;

const StatValue = styled.span`
    font-size: 16px;
    font-weight: bold;
    color: green;

    @media all and (max-width:479px) {
        font-size: 0.5rem;
    }
`;

const AbilityDescription = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    background-color: #333;
    color: white;
    padding: 10px;
    border-radius: 5px;
    width: 300px;
    display: ${({ show }) => (show ? "block" : "none")};
    z-index: 10;
    margin-top: 5px;

    @media all and (max-width:479px) {
        font-size: 0.5rem;

        width: 20vw;
        text-overflow: clip;
    }
`;

function DetailTypeBox({ pokemonData }) {
    const [hoveredAbility, setHoveredAbility] = useState(null);

    const statLabels = {
        hp: "체력",
        attack: "공격",
        defense: "방어",
        "special-attack": "특수공격",
        "special-defense": "특수방어",
        speed: "스피드"
    };

    return (
        <DetailContainer>
            <TypeBox>
                <StyledTitle>타입</StyledTitle>
                <CategoryBox>
                    {pokemonData.types.map((type, index) => (
                        <StyledSpan key={index} type={type.koreanName.toLowerCase()}>
                            {type.koreanName}
                        </StyledSpan>
                    ))}
                </CategoryBox>
            </TypeBox>

            {/* 특성 */}
            <PropertyBox>
                <StyledTitle>특성</StyledTitle>
                <CategoryBox>
                    {pokemonData.abilities.map((ability, index) => (
                        <PropertySpan
                            key={index}
                            onMouseEnter={() => setHoveredAbility(ability)}
                            onMouseLeave={() => setHoveredAbility(null)}
                        >
                            {ability.name}
                            {/* 능력 설명을 hover 했을 때만 보이도록 */}
                            <AbilityDescription show={hoveredAbility === ability}>
                                {ability.effect}
                            </AbilityDescription>
                        </PropertySpan>
                    ))}
                </CategoryBox>
            </PropertyBox>

            {/* 기본 스탯 */}
            <StatsBox>
                <StyledTitle>기본 스탯</StyledTitle>
                <CategoryBox>
                    {pokemonData.stats.map((stat, index) => (
                        <StatBox key={index}>
                            <StatLabel>{statLabels[stat.name] || stat.name}</StatLabel>
                            <StatValue>{stat.base_stat}</StatValue>
                        </StatBox>
                    ))}
                </CategoryBox>
            </StatsBox>
        </DetailContainer>
    );
}

export default DetailTypeBox;
